import React from 'react';
import {FormattedMessage} from 'react-intl';

import {useGetTranslations} from 'utils/hooks/useGetTranslations';
import {TranslationKeys} from 'utils/constants/routeConstants';
import './styles.scss';

export const AccessDenied: React.FunctionComponent = () => {
  useGetTranslations({
    translationKey: TranslationKeys.Error
  });

  return <div className={'access-denied'}>
    <div>
      <h2 className="access-denied__text">
        <FormattedMessage
          id="gritx.error.accessDenied"
          defaultMessage="You are denied access to this site, please go to {link}"
          values={{
            link: (
              <a href="https://jun.scalable.care" target="_blank" rel="noopener noreferrer">
                jun.scalable.care
              </a>
            )
          }}
        />
      </h2>
    </div>
  </div>;
};
